import gql from 'graphql-tag';

// import { ACTIVITY_FRAGMENT } from '../fragments';
import { ERROR_FRAGMENT } from '../fragments';

const mutationName = 'createAdmin';

export const CREATE_USER = {
  mutationName,
  mutationBody: gql`
    mutation ${mutationName}(
      $input: CreateAdminMutationInput!
    ) {
      ${mutationName}(
        input: $input
      ) {
        user {
          id
          firstName
          lastName
          email
          isStaff
        }
        errors {
          ...errors
        }
      }
    }
    ${ERROR_FRAGMENT}
  `,
};

const deleteName = 'deleteAdmin';

export const DELETE_USER = {
  mutationName: deleteName,
  mutationBody: gql`
  mutation ${deleteName}(
    $input: DeleteAdminMutationInput!
  ) {
    ${deleteName}(
      input: $input
    ) {
      admin{
        id
        email
        
      }
      status
      errors {
        ...errors
      }
    }
  }
  ${ERROR_FRAGMENT}
`,
};

const updateAdminMutationName = 'updateAdmin';

export const UPDATE_USER = {
  mutationName: updateAdminMutationName,
  mutationBody: gql`
    mutation ${updateAdminMutationName}(
      $input: UpdateAdminMutationInput!
    ) {
      ${updateAdminMutationName}(
        input: $input
      ) {
        user{
          id
          email
          firstName
          lastName
          telephone
          organizer{
            name
            id
          }
          roles{
            id
            name
          }
        }
        errors {
          ...errors
        }
      }
    }
    ${ERROR_FRAGMENT}
  `,
};
